import axiosInstance from "api/axiosInstance";

import type { AdminBrand, AdminBrandCreateRequest, AdminBrandListParams, AdminBrandUpdateRequest } from "api/types/brand.types";

export interface Brand {
  id: number;
  name: string;
  description: string;
  is_active: boolean;
}

const BASE = "/server/buccl_user/api/v1/brands/";
const ADMIN_BASE = "/server/buccl_user/api/v1/admin/brands/";

export const brandsService = {
  /** 공개 목록 (활성 브랜드만). 셀렉트 박스 등에서 사용 */
  list: () => axiosInstance.get<Brand[]>(BASE),

  /** 어드민 목록 — 비활성 브랜드 포함, name asc 정렬 */
  adminList: (params?: AdminBrandListParams) => axiosInstance.get<AdminBrand[]>(ADMIN_BASE, { params }),

  adminGet: (id: number) => axiosInstance.get<AdminBrand>(`${ADMIN_BASE}${id}/`),

  adminCreate: (payload: AdminBrandCreateRequest) => axiosInstance.post<AdminBrand>(ADMIN_BASE, payload),

  adminUpdate: (id: number, payload: AdminBrandUpdateRequest) => axiosInstance.patch<AdminBrand>(`${ADMIN_BASE}${id}/`, payload),

  /** 하드 삭제 엔드포인트는 없다. 비활성화가 삭제를 대체한다 */
  adminDeactivate: (id: number) => axiosInstance.patch<AdminBrand>(`${ADMIN_BASE}${id}/`, { is_active: false }),
};
